// Copyright (c) Docugami, Inc. All rights reserved.

import { Component, ComponentId } from "sdv/engine/Component";
import { Entity, IEntityManager } from "sdv/engine/Entity";
import { Box } from "store/shared_types";

export enum InteractionType {
    Hover,
    Drag,
    Click
}

export interface InteractableComponent extends Component {
    typeId: ComponentId.Interactable;
    interactionType: InteractionType;
    hitBox: Box;
    disabled?: boolean;
    onInteractStart?: (entity: Entity, entities: IEntityManager) => void;
    onInteractEnd?: (entity: Entity, entities: IEntityManager) => void;
    onClick?: () => void;
}
